// extracted by mini-css-extract-plugin
module.exports = {"search_form":"SearchForm_search_form__3R4Bg","search_input_wrapper":"SearchForm_search_input_wrapper__9n6B4"};